import {
  GridDateOperator,
  GridNumericOperator,
  GridSelectOperator,
  GridStringOperator,
} from '@packages/fenrir/components/datagrid';

import type {
  RiskParam,
  FilterMapItem,
} from '../../filter-management/filter-map-item';
import {
  getDateArray,
  getString,
  getStringArray,
} from '../../filter-management/filter-parameters';

import {
  ALL_RISKS_COLUMN_DEFS,
  allRisksRangeFilters,
} from './all-risks-table.constants';

export const AllRisksFilterMap: FilterMapItem<RiskParam>[] = [
  {
    column: ALL_RISKS_COLUMN_DEFS.STATE,
    paramKey: 'state',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.STATUS,
    paramKey: 'status',
    operator: GridSelectOperator.Is,
    getValue: getString,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSET_CRITICALITY,
    paramKey: 'assetImportance',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.SOURCE,
    paramKey: 'source',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.SEVERITY,
    paramKey: 'severity',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.RESOLUTION_TYPE,
    paramKey: 'resolutionType',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.SCORE,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.SCORE].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.SCORE].to,
    ],
    operator: GridNumericOperator.isBetween,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.CVSSV3,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.CVSSV3].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.CVSSV3].to,
    ],
    operator: GridNumericOperator.isBetween,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.FIRST_DETECTED_TIME,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.FIRST_DETECTED_TIME].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.FIRST_DETECTED_TIME].to,
    ],
    operator: GridDateOperator.isBetween,
    getValue: getDateArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.LAST_DETECTED_TIME,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.LAST_DETECTED_TIME].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.LAST_DETECTED_TIME].to,
    ],
    operator: GridDateOperator.isBetween,
    getValue: getDateArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.RESOLUTION_TIME,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.RESOLUTION_TIME].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.RESOLUTION_TIME].to,
    ],
    operator: GridDateOperator.isBetween,
    getValue: getDateArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.DEADLINE,
    paramKey: [
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.DEADLINE].from,
      allRisksRangeFilters[ALL_RISKS_COLUMN_DEFS.DEADLINE].to,
    ],
    operator: GridDateOperator.isBetween,
    getValue: getDateArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSET_CATEGORY,
    paramKey: 'deviceCategory',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSET_OS_NAME,
    paramKey: 'deviceOSFamily',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.SEARCH,
    paramKey: 'search',
    operator: GridStringOperator.Contains,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSIGNEE,
    paramKey: 'assignee',
    operator: GridSelectOperator.isAnyOf,
    getValue: getStringArray,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.CISA_KEV,
    paramKey: 'cisaKnownExploit',
    operator: GridSelectOperator.Is,
    getValue: getString,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSET_ID,
    paramKey: 'assetID',
    operator: GridStringOperator.Equals,
    getValue: getString,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ISSUE_ID,
    paramKey: 'issueID',
    operator: GridStringOperator.Equals,
    getValue: getString,
  },
  {
    column: ALL_RISKS_COLUMN_DEFS.ASSET_TYPE,
    paramKey: 'assetType',
    operator: GridStringOperator.isAnyOf,
    getValue: getString,
  },
];
